import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core';

const styles = {
    searchForm: {
        width: '100%',
        minWidth: '150px',
    },
    inputHeight: {
        height: 5,
    },
    cssFocused: {},
    notchedOutline: {},
    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderWidth: '1px !important',
        },
        height: 40,
    },
};

const SearchBox = ({ refine, classes, defaultRefinement }) => {
    return (
        <form noValidate action="" role="search" className={classes.searchForm} onSubmit={(e) => e.preventDefault()}>
            <TextField
                type="search"
                variant="outlined"
                value={defaultRefinement}
                onChange={(event) => refine(event.currentTarget.value)}
                fullWidth={true}
                margin="dense"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                    },
                }}
            />
        </form>
    );
};

export default withStyles(styles)(SearchBox);
